<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('projects')"
      :columns="columns"
      :column_search="true"
      :page_length="100"
      resource_url="/air_project/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <project-modal ref="project_modal" @success="refresh" />
  <photos-modal ref="photos_modal" @success="refresh" />
  <administrative-documents-modal
    ref="administrative_documents_modal"
    @success="refresh"
  />
  <report-modal ref="report_modal" :module_settings="module_settings" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
} from "@/utils";
import ProjectModal from "./project_modal/Index.vue";
import PhotosModal from "./photos_modal/Index.vue";
import AdministrativeDocumentsModal from "./administrative_documents_modal/Index.vue";
import ReportModal from "./report_modal/Index.vue";

export default {
  name: "ProjectsDatatable",
  components: {
    GenericTable,
    ProjectModal,
    PhotosModal,
    ReportModal,
    AdministrativeDocumentsModal,
  },
  props: { module_settings: Object },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "create_date",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.format_date(row.create_date) || "";
          },
        },
        {
          title: v.$t("name"),
          name: "name",
          width: "40%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="control">
                      <div class="tags has-addons">
                        <span class="tag is-dark">${v.$t(row.type)}</span>
                        <span class="tag is-info">${row.name}</span>
                        <span class="tag is-primary">${
                          row.settings.advisor
                        }</span>
                      </div>
                    </div>`;
          },
        },
        {
          title: v.$t("status"),
          name: "status",
          width: "10%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.$t(row.status);
          },
        },
        {
          title: v.$t("options"),
          width: "35%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.project_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("photos"),
                icon: "fa fa-camera",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.photos_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("administrative documents"),
                icon: "fa fa-file",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.administrative_documents_modal.show_modal(
                    e.detail.uuid
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("report"),
                icon: "fa fa-line-chart",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.report_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete project?"),
                    v,
                    () => {
                      del("/air_project", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    create() {
      let v = this;
      v.$refs.project_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
